import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";

export const ComparisonOperators = [
    {
        name: "Equals",
        symbol: "="
    },
    {
        name: "Greater Than",
        symbol: ">"
    },
    {
        name: "Less Than",
        symbol: "<"
    },
    {
        name: "Greater Or Equals",
        symbol: ">="
    },
    {
        name: "Less Or Equals",
        symbol: "<="
    },
    {
        name: "Not Equals",
        symbol: "!="
    }
];

export const ComparisonSelect = ({ name , classNames , value , onChange } ) => {

    return <select name={name} value={value} className={classNames} style={{ width: "100%" }} onChange={evt => {

        const _value = evt.target.value;

        if(_.isFunction(onChange))
            onChange(_value);

    }}>
        {ComparisonOperators.map((operator,key) => (<option key={key} value={operator.symbol}>{operator.symbol}</option>))}
    </select>;

};


ComparisonSelect.propTypes = {
    name: PropTypes.string,
    onChange: PropTypes.func,
    classNames: PropTypes.string,
    value: PropTypes.string
};

ComparisonSelect.defaultProps = {
    initialValue: ComparisonOperators[0].symbol,
    classNames: "form-control form-input-select"
};



// WEBPACK FOOTER //
// ./src/components/CRUDView/Components/ComparisonSelect.js